<template>
    <div v-if="gateway_refund_setting">
        <kt-panel>
            <kt-panel-body>
                <form id="update_refund_settings_form">
                    <kt-row style="margin-top: 20px">
                        <kt-col xs="12" sm="6" md="4" lg="3">
                            <kt-form-group>
                                <kt-form-label>
                                    {{ $t('application.refund_account_number') }}
                                </kt-form-label>
                                <kt-form-select
                                    size="4"
                                    id="bank_account_id"
                                    name="bank_account_id"
                                    v-model="gateway_refund_setting.id"
                                >
                                    <option
                                        v-bind:key="index"
                                        v-for="(bank_account, index) in bank_accounts"
                                        v-bind:value="bank_account.id"
                                        :selected="bank_account.id"
                                    >
                                        {{ bank_account.account_number }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col xs="12" sm="6" md="4" lg="3">
                            <kt-form-group>
                                <kt-form-label>
                                    {{ $t('application.wage_payer') }}
                                </kt-form-label>
                                <kt-form-select
                                    size="4"
                                    id="wage_payer"
                                    name="wage_payer"
                                    v-model="gateway_refund_setting.wage_payer"
                                >
                                    <option
                                        v-bind:key="index"
                                        v-for="(wage_payer, index) in wage_payers"
                                        v-bind:value="wage_payer.value"
                                        :selected="wage_payer.value"
                                    >
                                        {{ wage_payer.title }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-form-action style="text-align: end">
                        <button class="btn btn-md btn-success" type="button"
                                @click="edit"
                                id="update_refund_settings_btn">
                            {{ $t('btn.edit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </div>
</template>

<script>
import {KTUtil} from '@/plugins/core/util';
import {KTApp} from "@/plugins/core/app";
import {openBankingService} from "@/common/api.service";
import {bankIdStr} from '@/constants/bankId'
import $ from "jquery";
import toastr from "toastr";
import {i18n} from '@/plugins/i18n';

export default {
    components: {},
    props: ['bank_accounts'],
    mounted() {
        this.fetchSettings();
    },
    data() {
        return {
            'hashid': this.$route.params.hashid,
            gateway_refund_setting: null,
            bankIdStr,
            active_bank_accounts: null,
            wage_payers :[
                {
                    title : i18n.t('gateway.wages.from_acceptor'),
                    value: 1
                },
                {
                    title : i18n.t('gateway.wages.from_payer'),
                    value: 2
                }
            ]
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {
        edit() {
            let btn = $('#update_refund_settings_btn')
            let form = $('#update_refund_settings_form')

            let params = {
                wage_payer :  this.gateway_refund_setting.wage_payer
            }

            if (this.gateway_refund_setting.id){
                params.bank_account_id = this.gateway_refund_setting.id
            }
            KTApp.progress(btn)
            openBankingService.adminUpdateGatewayRefundSetting(this.hashid, params).then(response => {
                this.showMsg(form, 'success', response.data.message);
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message);
            }).finally(response => {
                KTApp.unprogress(btn)
                KTUtil.scrollTop();
            })
        },
        afterDispatch() {
            $('.kt-selectpicker-app-details').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        fetchSettings() {
            openBankingService.adminGetGatewayRefundSetting(this.hashid).then(response => {
                this.gateway_refund_setting = response.data.data.gateway_refund_settings;
                this.afterDispatch()
            });
        }
    }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>